<div class="content">
  <app-advanced-filters #advancedFilters (loadData)="applyFilters($event)"
    (topValue)="updateTopValue($event)"
    (dateRangeFilterUpdated)="updateDownloadBasedOnItemsButton($event)"
    (shopsOrPrintersFilterUpdated)="updateDownloadBasedOnItemsButton($event)"></app-advanced-filters>
  <div class="container" [style.top.px]="containerTopValue" [style.height]="calcContainerHeight()" *ngIf="showTable">
          <div class="table-container mat-elevation-z3">
            <table class="sales-statement-table" mat-table [dataSource]="summary">
              <ng-container matColumnDef="shopNumber">
                <th mat-header-cell *matHeaderCellDef> {{'common.shop' | translate}} </th>
                <td mat-cell *matCellDef="let data"
                  [attr.colspan]="isSummaryForShop(data) || isSummaryForDay(data) || isSummaryForPrinter(data) ? (filters.basedOnReceipts ? 4 : 5 ) : 0">

                  <ng-container *ngIf="isSummaryForShop(data)">
                    {{'reports.sales-statement.summary-for-shop' | translate}}: {{ data.shopNumber }}
                  </ng-container>

                  <ng-container *ngIf="isSummaryForDay(data)">
                    {{'reports.sales-statement.summary-for-day' | translate}}: {{ data.date | date:'yyyy-MM-dd' }}
                  </ng-container>

                  <ng-container *ngIf="isSummaryForPrinter(data)">
                    {{'reports.sales-statement.summary-for-printer' | translate}}: {{ data.printerNumber }}
                  </ng-container>

                  <ng-container *ngIf="!isSummaryForShop(data) && !isSummaryForDay(data) && !isSummaryForPrinter(data)">
                    {{data.shopNumber}}
                  </ng-container>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                  {{'reports.sales-statement.summary-total' | translate}}
                </td>
              </ng-container>

              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> {{(filters.useBusinessDate ? 'reports.sales-statement.business-date' : 'common.date') | translate}} </th>
                <td mat-cell *matCellDef="let data"
                  [style.display]="!isSummaryForShop(data) && !isSummaryForDay(data) && !isSummaryForPrinter(data) ? '' : 'none'">
                  {{data.date | date:'yyyy-MM-dd'}}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <ng-container matColumnDef="printerNumber">
                <th mat-header-cell *matHeaderCellDef> {{'common.printer' | translate}} </th>
                <td mat-cell *matCellDef="let data"
                  [style.display]="!isSummaryForShop(data) && !isSummaryForDay(data) && !isSummaryForPrinter(data) ? '' : 'none'">
                  {{ data.printerNumber }}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <ng-container matColumnDef="documentNumber">
                <th mat-header-cell *matHeaderCellDef> {{('reports.sales-statement.' + (filters.basedOnReceipts ? 'receipt-no' : 'daily-report-no')) | translate}} </th>
                <td mat-cell *matCellDef="let data"
                  [style.display]="!isSummaryForShop(data) && !isSummaryForDay(data) && !isSummaryForPrinter(data) ? '' : 'none'">
                  <button mat-icon-button color="primary" aria-label="Preview" (click)="previewOpenDialog(data)">
                    <fa-icon [icon]="faPreview" size="lg"></fa-icon>
                  </button>
                  {{ data.documentNumber }}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              <ng-container matColumnDef="receiptCount">
                <th mat-header-cell *matHeaderCellDef> {{'reports.sales-statement.receipt-count' | translate}} </th>
                <td mat-cell *matCellDef="let data"
                  [style.display]="!isSummaryForShop(data) && !isSummaryForDay(data) && !isSummaryForPrinter(data) ? '' : 'none'">
                  {{ data.receiptCount }}
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>

              
              <ng-container *ngFor="let vatRate of activeVatRates" [matColumnDef]="getColumnName(vatRate[0])">
                <th mat-header-cell *matHeaderCellDef>
                  {{'reports.sales-statement.net' | translate}} {{vatRate[1]}}<br />
                  {{'reports.sales-statement.vat' | translate}} {{vatRate[1]}}
                </th>
                <td mat-cell *matCellDef="let data">
                  {{data['net' + vatRate[0]] | currency: ' '}} <br />
                  {{data['vat' + vatRate[0]] | currency: ' '}}
                </td>
                <td mat-footer-cell *matFooterCellDef>
                  {{totalSummary['net' + vatRate[0]] | currency: ' '}} <br />
                  {{totalSummary['vat' + vatRate[0]] | currency: ' '}}
                </td>
              </ng-container>

              <ng-container matColumnDef="gross">
                <th mat-header-cell *matHeaderCellDef> {{'reports.sales-statement.gross' | translate}} </th>
                <td mat-cell *matCellDef="let data"> {{data.gross | currency: ' '}} </td>
                <td mat-footer-cell *matFooterCellDef> {{totalSummary.gross | currency: ' '}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [class.summary]="isSummaryForShop(row) || isSummaryForDay(row) || isSummaryForPrinter(row)"
                [class.summary-for-day]="isSummaryForDay(row)"
                [class.summary-for-shop]="isSummaryForShop(row)"
                [class.summary-for-printer]="isSummaryForPrinter(row)"
                [class.active]="currentPreview(row.fileId)">
              </tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"
                [class.summary-total]="summary.length > 0" class="summary" [hidden]="isTotalSummaryEmpty()"></tr>

            </table>

            <div class="empty-results" *ngIf="summary.length === 0 && isTotalSummaryEmpty()">
              {{'common.empty-results' | translate}}
            </div>
    </div>
  </div>
</div>